import React, { Component } from 'react'
import { connect } from 'react-redux'
// import async from 'async'

// import styles
import './companystyling.scss'

// Elements
import Row from '../../../shared/elements/row'
import Panel from '../../../shared/elements/panel'
import Col from '../../../shared/elements/col'
import DropDown from '../../../shared/elements/dropDown'
// import Label from '../../../shared/elements/label'

// Utils
import { translation } from '../../../utils/helpers'
import Text from '../../../shared/elements/text'
import Color from '../../../shared/elements/color'
import { FILE_STORAGE } from '../../../constants'
import Dropzone from '../../../shared/components/Dropzone'
import Gallery from '../../../shared/components/Gallery'

// Actions
import { uploadLogo, getLogo, deleteLogo } from '../../../actions/carownerportal'
import { getPortalStyling, postPortalStyling } from '../../../actions/settings'
import Radio from '../../../shared/elements/radio'
import RemoveButton from '../../../shared/elements/removeButton'
import Portal from '../../../shared/components/Portal'
import Confirm from '../../../shared/components/Confirm'
import Divider from '../../../shared/elements/divider'
import PanelHeader from '../../../shared/elements/panelHeader'
import LabelWrapper from '../../../shared/elements/labelWrapper'

const fonts = ['Arial', 'Verdana', 'Helvetica', 'Tahoma', 'Trebuchet MS', 'Times New Roman', 'Georgia', 'Garamond', 'Courier New', 'Brush Script MT']

const fontSizes = Array.from({ length: 45 }, (v, k) => k + 4)

class CompanyStyling extends Component {
  constructor (props) {
    super(props)
    this.state = {
      FontType: 1,
      WebSafeFont: 'Arial',
      FontURL: '',
      FontFamily: '',
      BrandColor: '#000000',
      BrandColorSecondary: '#000000',
      PrimaryBackgroundColor: '#000000',
      ColoredBackground: '#000000',
      H1Size: 40,
      H1Color: '#000000',
      H2Size: 40,
      H2Color: '#000000',
      BodySize: 40,
      BodyColor: '#000000',
      NavigationSize: 40,
      NavigationColor: '#000000',
      LinkSize: 40,
      LinkColor: '#000000',
      ButtonTextSize: 40,
      ButtonTextColor: '#000000',
      ButtonStrokeColor: '#000000',
      ButtonFillColor: '#000000',
      HoverStrokeColor: '#000000',
      HoverFillColor: '#000000',
      CheckboxColor: '#000000',
      CheckboxActiveColor: '#000000',
      BackButtonTextSize: 40,
      BackButtonTextColor: '#000000',
      BackButtonStrokeColor: '#000000',
      BackButtonFillColor: '#000000',
      BackButtonHoverStrokeColor: '#000000',
      BackButtonHoverFillColor: '#000000',
      InputFieldColor: '#000000',
      EmptyFieldTextColor: '#000000',
      EmptyFieldTextSize: 40,
      Logo: null,
      upload: {
        loading: false,
        errors: []
      },
      confirmFileDelete: {
        confirm: false,
        file: null
      },
      errors: []
    }

    this.handleClickSave = this.updateStyling.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.onTextChange = this.onTextChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.onDrop = this.onDrop.bind(this)
    this.onDropAccepted = this.onDropAccepted.bind(this)
    this.onDropRejected = this.onDropRejected.bind(this)
    this.renderImage = this.renderImage.bind(this)
  }

  componentDidMount () {
    this.getData()
    this.getLogo()
  }

  componentWillUnmount () {
    this._mounted = false
    window.removeEventListener('resize', this.fnListener)
    clearInterval(this.checkFileTimer)
  }

  getData () {
    this.props.getPortalStyling().then((res) => {
      this.setState(res.data)
    })
  }

  getLogo () {
    this.props.getLogo().then((res) => {
      this.setState({ Logo: res.data })
    })
  }

  updateStyling (e) {
    this.props.postPortalStyling(JSON.parse(JSON.stringify(this.state))).then((res) => {
      this.setState({...res.data})
    })
  }

  onInputChange (name, value) {
    if (Number.isInteger((parseInt(value)))) value = parseInt(value)
    this.setState({ [name]: value }, () => {
      this.updateStyling()
    })
  }

  onTextChange (e) {
    console.log('onTextChange', e.target.name, 'value', e.target.value)
    this.setState({ [e.target.name]: e.target.value })
  }

  onBlur (e) {
    this.updateStyling()
  }

  onDrop () {
    this.setState({ upload: { ...this.state.upload, errors: [] } })
  }

  onDropAccepted (files) {
    this.setState({
      upload: {
        ...this.state.upload,
        files: files,
        loading: true
      }
    }, () => {
      this.props.uploadLogo(this.state.upload.files[0]).then(res => {
        this.setState({ upload: { ...this.state.upload, files: [], loading: false } })
        this.setState({ Logo: res.data })
      })
    })
  }

  onDropRejected (files) {
    let newErrors = []
    files.map((file) => {
      newErrors.push(translation('1207') + ': ' + file.name + ' ' + translation('13405') + '.')
    })
    this.setState({ upload: { ...this.state.upload, errors: newErrors, files: [] } })
  }

  deleteFile (file) {
    let confirm = {
      confirm: true,
      file: file
    }
    this.setState({
      confirmFileDelete: confirm
    })
  }

  renderImage (image, index) {
    if (image != null) {
      const url = FILE_STORAGE + image.FileURL
      return (
        <div className='image-div' key={index}>
          <a href={url} data-lightbox='gallery' data-title={image.FileName}><img src={url} /></a>
          <RemoveButton size='s' onClick={() => this.deleteFile(image)} />
        </div>
      )
    }
  }

  render () {
    // let { errors } = this.state.upload
    let images = [this.state.Logo]

    const onPortalClose = () => {
      let confirm = {
        confirm: false,
        file: null
      }
      this.setState({
        confirmFileDelete: confirm
      })
    }

    const onConfirm = () => {
      let file = this.state.confirmFileDelete.file
      let confirm = {
        confirm: false,
        file: null
      }
      this.setState({
        confirmFileDelete: confirm
      }, () => {
        let newErrors = []
        this.props.deleteLogo().then((res) => {
          this.setState({ Logo: null })
        }, () => {
          newErrors.push(translation('1207') + ': ' + file.FileName + '' + translation('13406') + '.')
          this.setState({
            upload: { ...this.state.upload, errors: newErrors }
          })
        })
      })
    }

    return (
      <div className='company-styling'>
        <Row>
          <Col span={2}>
            <Panel title={translation(18188)}>
              <LabelWrapper labelText='Font type'>
                <div className='row-container row-1col'>
                  <div className='col-container'>
                    <Radio name='FontType' value={1} checked={this.state.FontType === 1} onChange={e => this.onInputChange(e.target.name, e.target.value)} labelText={translation(18194)} />
                    <DropDown name='WebSafeFont' onChange={(e) => this.onInputChange('WebSafeFont', e.target.value)} value={this.state.WebSafeFont} spacing={1}>
                      {fonts.map(f => <option value={f} key={f}>{f}</option>)}
                    </DropDown>
                  </div>
                </div>
                <div className='row-container row-1col'>
                  <div className='col-container'>
                    <Radio name='FontType' value={2} checked={this.state.FontType === 2} onChange={e => this.onInputChange(e.target.name, e.target.value)} labelText={translation(18195)} />
                  </div>
                </div>
              </LabelWrapper>
              <Text name='FontURL' value={this.state.FontURL} labelText={18195} onChange={this.onTextChange} onBlur={this.onBlur} helpText={18260} />
              <Text name='FontFamily' value={this.state.FontFamily} labelText={18258} onChange={this.onTextChange} onBlur={this.onBlur} helpText={18261} />

              <Divider noLine size={3} />

              <PanelHeader text={translation(18196)} />
              <div className='row-container row-2col'>
                <div className='col-container'>
                  <Color name='BrandColor' onChange={(e) => this.onInputChange('BrandColor', e.target.value)} labelText={translation(18288)} value={this.state.BrandColor} />
                </div>
                <div className='col-container'>
                  <Color name='BrandColorSecondary' onChange={(e) => this.onInputChange('BrandColorSecondary', e.target.value)} labelText={translation(18289)} value={this.state.BrandColorSecondary} />
                </div>
              </div>
              <div className='row-container row-2col'>
                <div className='col-container'>
                  <Color name='PrimaryBackgroundColor' onChange={(e) => this.onInputChange('PrimaryBackgroundColor', e.target.value)} labelText={translation(18290)} value={this.state.PrimaryBackgroundColor} />
                </div>
                <div className='col-container'>
                  <Color name='ColoredBackground' onChange={(e) => this.onInputChange('ColoredBackground', e.target.value)} labelText={translation(18291)} value={this.state.ColoredBackground} />
                </div>
              </div>

              <PanelHeader text={translation(18197)} />
              <div className='row-container row-2col'>
                <div className='col-container'>
                  <DropDown name='H1Size' onChange={(e) => this.onInputChange('H1Size', e.target.value)} value={this.state.H1Size} labelText={translation(13340)}>
                    {fontSizes.map(f => <option value={f} key={f}>{f}px</option>)}
                  </DropDown>
                </div>
                <div className='col-container'>
                  <Color name='H1Color' onChange={(e) => this.onInputChange('H1Color', e.target.value)} labelText={translation(18213)} value={this.state.H1Color} />
                </div>
              </div>

              <PanelHeader text={translation(18198)} />
              <div className='row-container row-2col'>
                <div className='col-container'>
                  <DropDown name='h2size' onChange={(e) => this.onInputChange('H2Size', e.target.value)} value={this.state.H2Size} labelText={translation(13340)}>
                    {fontSizes.map(f => <option value={f} key={f}>{f}px</option>)}
                  </DropDown>
                </div>
                <div className='col-container'>
                  <Color name='H2Color' onChange={(e) => this.onInputChange('H2Color', e.target.value)} labelText={translation(18213)} value={this.state.H2Color} />
                </div>
              </div>

              <PanelHeader text={translation(18208)} />
              <div className='row-container row-2col'>
                <div className='col-container'>
                  <DropDown name='BodySize' onChange={(e) => this.onInputChange('BodySize', e.target.value)} value={this.state.BodySize} labelText={translation(13340)}>
                    {fontSizes.map(f => <option value={f} key={f}>{f}px</option>)}
                  </DropDown>
                </div>
                <div className='col-container'>
                  <Color name='BodyColor' onChange={(e) => this.onInputChange('BodyColor', e.target.value)} labelText={translation(18213)} value={this.state.BodyColor} />
                </div>
              </div>

              <PanelHeader text={translation(18199)} />
              <div className='row-container row-2col'>
                <div className='col-container'>
                  <DropDown name='NavigationSize' onChange={(e) => this.onInputChange('NavigationSize', e.target.value)} value={this.state.NavigationSize} labelText={translation(13340)}>
                    {fontSizes.map(f => <option value={f} key={f}>{f}px</option>)}
                  </DropDown>
                </div>
                <div className='col-container'>
                  <Color name='NavigationColor' onChange={(e) => this.onInputChange('NavigationColor', e.target.value)} labelText={translation(18213)} value={this.state.NavigationColor} />
                </div>
              </div>

              <PanelHeader text={translation(18200)} />
              <div className='row-container row-2col'>
                <div className='col-container'>
                  <DropDown name='LinkSize' onChange={(e) => this.onInputChange('LinkSize', e.target.value)} value={this.state.LinkSize} labelText={translation(13340)}>
                    {fontSizes.map(f => <option value={f} key={f}>{f}px</option>)}
                  </DropDown>
                </div>
                <div className='col-container'>
                  <Color name='LinkColor' onChange={(e) => this.onInputChange('LinkColor', e.target.value)} labelText={translation(18213)} value={this.state.LinkColor} />
                </div>
              </div>

              <PanelHeader text={translation(18201)} />
              <div className='row-container row-2col'>
                <div className='col-container'>
                  <DropDown name='ButtonTextSize' onChange={(e) => this.onInputChange('ButtonTextSize', e.target.value)} value={this.state.ButtonTextSize} labelText={translation(13340)}>
                    {fontSizes.map(f => <option value={f} key={f}>{f}px</option>)}
                  </DropDown>
                </div>
                <div className='col-container'>
                  <Color name='ButtonTextColor' onChange={(e) => this.onInputChange('ButtonTextColor', e.target.value)} labelText={translation(18203)} value={this.state.ButtonTextColor} />
                </div>
              </div>
              <div className='row-container row-2col'>
                <div className='col-container'>
                  <Color name='ButtonStrokeColor' onChange={(e) => this.onInputChange('ButtonStrokeColor', e.target.value)} labelText={translation(18204)} value={this.state.ButtonStrokeColor} />
                </div>
                <div className='col-container'>
                  <Color name='ButtonFillColor' onChange={(e) => this.onInputChange('ButtonFillColor', e.target.value)} labelText={translation(18205)} value={this.state.ButtonFillColor} />
                </div>
              </div>
              <div className='row-container row-2col'>
                <div className='col-container'>
                  <Color name='HoverStrokeColor' onChange={(e) => this.onInputChange('HoverStrokeColor', e.target.value)} labelText={translation(18298)} value={this.state.HoverStrokeColor} />
                </div>
                <div className='col-container'>
                  <Color name='HoverFillColor' onChange={(e) => this.onInputChange('HoverFillColor', e.target.value)} labelText={translation(18292)} value={this.state.HoverFillColor} />
                </div>
              </div>
              {/* Back button */}
              <PanelHeader text={translation(18328)} />
              <div className='row-container row-2col'>
                <div className='col-container'>
                  <DropDown name='BackButtonTextSize' onChange={(e) => this.onInputChange('BackButtonTextSize', e.target.value)} value={this.state.BackButtonTextSize} labelText={translation(13340)}>
                    {fontSizes.map(f => <option value={f} key={f}>{f}px</option>)}
                  </DropDown>
                </div>
                <div className='col-container'>
                  <Color name='BackButtonTextColor' onChange={(e) => this.onInputChange('BackButtonTextColor', e.target.value)} labelText={translation(18203)} value={this.state.BackButtonTextColor} />
                </div>
              </div>
              <div className='row-container row-2col'>
                <div className='col-container'>
                  <Color name='BackButtonStrokeColor' onChange={(e) => this.onInputChange('BackButtonStrokeColor', e.target.value)} labelText={translation(18204)} value={this.state.BackButtonStrokeColor} />
                </div>
                <div className='col-container'>
                  <Color name='BackButtonFillColor' onChange={(e) => this.onInputChange('BackButtonFillColor', e.target.value)} labelText={translation(18205)} value={this.state.BackButtonFillColor} />
                </div>
              </div>
              <div className='row-container row-2col'>
                <div className='col-container'>
                  <Color name='BackButtonHoverStrokeColor' onChange={(e) => this.onInputChange('BackButtonHoverStrokeColor', e.target.value)} labelText={translation(18298)} value={this.state.BackButtonHoverStrokeColor} />
                </div>
                <div className='col-container'>
                  <Color name='BackButtonHoverFillColor' onChange={(e) => this.onInputChange('BackButtonHoverFillColor', e.target.value)} labelText={translation(18292)} value={this.state.BackButtonHoverFillColor} />
                </div>
              </div>
              {/* Empty field text */}
              <PanelHeader text={translation(18330)} />
              <div className='row-container row-2col'>
                <div className='col-container'>
                  <DropDown name='EmptyFieldTextSize' onChange={(e) => this.onInputChange('EmptyFieldTextSize', e.target.value)} value={this.state.EmptyFieldTextSize} labelText={translation(13340)}>
                    {fontSizes.map(f => <option value={f} key={f}>{f}px</option>)}
                  </DropDown>
                </div>
                <div className='col-container'>
                  <Color name='EmptyFieldTextColor' onChange={(e) => this.onInputChange('EmptyFieldTextColor', e.target.value)} labelText={translation(18295)} value={this.state.EmptyFieldTextColor} />
                </div>
              </div>
              {/* Text color */}
              <PanelHeader text={translation(18329)} />
              <div className='row-container row-2col'>
                <div className='col-container'>
                  <Color name='InputFieldColor' onChange={(e) => this.onInputChange('InputFieldColor', e.target.value)} labelText={translation(18294)} value={this.state.InputFieldColor} />
                </div>
              </div>
              <PanelHeader text={translation(18293)} />
              <div className='row-container row-2col'>
                <div className='col-container'>
                  <Color name='CheckboxColor' onChange={(e) => this.onInputChange('CheckboxColor', e.target.value)} labelText={translation(18294)} value={this.state.CheckboxColor} />
                </div>
                <div className='col-container'>
                  <Color name='CheckboxActiveColor' onChange={(e) => this.onInputChange('CheckboxActiveColor', e.target.value)} labelText={translation(18295)} value={this.state.CheckboxActiveColor} />
                </div>
              </div>
            </Panel>
          </Col>
          <Col span={2}>
            <Panel title={translation(1702)}>
              <LabelWrapper labelText={translation(18214)}>
                <div className='row-container row-1col'>
                  <div className='col-container'>
                    <Dropzone
                      onDrop={this.onDrop}
                      onDropAccepted={this.onDropAccepted}
                      onDropRejected={this.onDropRejected}
                      multiple={false}
                      includeCircles={false}>
                      {this.state.upload.loading && (
                        <p className='loading'>
                          <span className='animated-background'>
                            <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
                            <span className='sr-only'>{translation(13382)}...</span>
                          </span>
                        </p>
                      )}
                      {!this.state.upload.loading && (
                        <div><p>{translation(16847)}</p></div>
                      )}
                    </Dropzone>
                  </div>
                </div>
                <div className='row-container row-1col'>
                  <div className='col-container'>
                    <div className='files_inner'>
                      <Gallery files={images} renderImage={this.renderImage} />
                    </div>
                  </div>
                  {this.state.confirmFileDelete.confirm && (
                    <Portal className='deleteModal' onPortalClose={onPortalClose}>
                      <Confirm confirm={onConfirm} notConfirm={onPortalClose} />
                    </Portal>
                  )}
                </div>
              </LabelWrapper>
            </Panel>
          </Col>
        </Row>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  uploadLogo,
  getLogo,
  deleteLogo,
  getPortalStyling,
  postPortalStyling
})(CompanyStyling)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/CompanyStyling/index.js